<template>
  <div class="d-flex flex-column w-100">
    <el-card class="mb-2" shadow="never">
      <h5 style="color: #101010" v-if="displayTitle">
        {{ displayTitle }}
      </h5>

      <div class="d-flex justify-content-between align-items-center">
        <div
          class="d-flex align-items-center text-truncate"
          style="
            font-size: 14px;
            color: #606266;
            height: 29px;
            line-height: 29px;
          "
        >
          <span class="mr-1">No:</span>
          <span>
            {{ baseInfo.sendSampleNo || $l('detail_placeholder_sendSampleNo') }}
          </span>
          <el-divider direction="vertical" />
          <el-tag
            size="mini"
            :type="
              baseInfo.sendSampleStatus === 'N'
                ? 'info'
                : baseInfo.sendSampleStatus === 'Y'
                ? 'primary'
                : baseInfo.sendSampleStatus === 'R'
                ? 'success'
                : baseInfo.sendSampleStatus === 'D'
                ? 'danger'
                : 'warning'
            "
          >
            {{ baseInfo.v_sendSampleStatus || 'New' }}
          </el-tag>

          <el-divider direction="vertical" />
          <span class="mr-1">Modify:</span>
          <span>
            {{ baseInfo.modifyByName || '--' }} at
            {{ baseInfo.modifyDate || '--' }}
          </span>
        </div>

        <div class="switch-tabs_wrappers">
          <div class="switch-tabs">
            <div
              v-for="item in switchTabs"
              :key="item.value"
              class="switch-tabs_items"
              :class="{
                active: item.value === activeName,
                disabled: item.disabled,
              }"
              @click="!item.disabled ? (activeName = item.value) : () => {}"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div class="flex-grow-1">
      <el-card v-show="activeName == 'base'" shadow="never">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :sendSampleCode="sendSampleCode"
          :custCode="custCode"
          :custName="custName"
          :sampleData="sampleData"
          @loaded="(data) => (baseInfo = data)"
        />
        <div class="d-flex justify-content-end mt-3">
          <el-button
            v-if="!disabled"
            type="primary"
            size="small"
            @click="$refs.editForm.saveCheck()"
          >
            {{ $l('btn_save') || '保存' }}
          </el-button>
        </div>
      </el-card>
      <el-card v-if="activeName == 'sample'" shadow="never" class="h-100">
        <SampleList
          :disabled="disabled"
          :sendSampleCode="sendSampleCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
      <el-card v-if="activeName == 'delivery'" shadow="never" class="h-100">
        <DeliveryLogs
          :disabled="disabled"
          :sendSampleCode="sendSampleCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SampleList from '../components/sample-list'
import DeliveryLogs from '../components/delivery-logs'
export default {
  name: 'customerManage-sendSample-detail',
  components: { EditForm, SampleList, DeliveryLogs },
  data() {
    return { baseInfo: {}, activeName: 'base' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    custCode() {
      return this.params.custCode
    },
    custName() {
      return this.params.custName
    },
    sampleData() {
      return this.params.sampleData
    },
    isCopy() {
      return this.pageType === 'copy'
    },
    disabled() {
      return this.pageType === 'detail'
    },
    sendSampleCode() {
      return this.params.sendSampleCode
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_base') || '基本信息',
          value: 'base',
        },
        {
          label: this.$l('switchTabs_label_sample') || '样品明细',
          value: 'sample',
          disabled: !this.sendSampleCode,
        },
        {
          label: this.$l('switchTabs_label_delivery') || '物流跟踪',
          value: 'delivery',
          disabled: !this.sendSampleCode,
        },
      ]
    },
    displayTitle() {
      if (!this.sendSampleCode) return ''
      const { custName, custProjectNo, salesPersonName } = this.baseInfo
      return [
        custName,
        custProjectNo,
        this.$l('form_label_sample_sending') || '样品寄样',
        salesPersonName,
      ]
        .filter(Boolean)
        .join(' ')
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
  .el-tag.el-tag--proofing-c {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
